import { render, staticRenderFns } from "./DefaultCommissionForm.vue?vue&type=template&id=29f8c4ac&scoped=true"
import script from "./DefaultCommissionForm.vue?vue&type=script&lang=js"
export * from "./DefaultCommissionForm.vue?vue&type=script&lang=js"
import style0 from "./DefaultCommissionForm.vue?vue&type=style&index=0&id=29f8c4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f8c4ac",
  null
  
)

export default component.exports